import type { QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';

import NotFoundPage from '~/pages/NotFoundPage';

export interface BaseRouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<BaseRouterContext>()({
  component: () => (
    <>
      <Outlet />
      <TanStackRouterDevtools />
      <ReactQueryDevtools />
    </>
  ),
  notFoundComponent: NotFoundPage,
  errorComponent: NotFoundPage,
});
